module.exports = __webpack_public_path__ + "img/yellow-bokeh.761ad835.jpg";